module.exports = __webpack_public_path__ + "img/cash-bag.94228701.svg";